import { Navigate } from 'react-router';

// Legacy entry point — the docs flow lives entirely on
// /professional/verify-identity now (which renders the right uploader
// for whichever selfie/video requirement the admin has configured).
// Keep the route alive so old email links / bookmarks land somewhere.
export default function StartRecordingPage() {
  return <Navigate to="/professional/verify-identity" replace />;
}
